module.exports = __webpack_public_path__ + "static/img/thumb_19.df4c997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_19.jpg
// module id = Ea6m
// module chunks = 0